// extracted by mini-css-extract-plugin
export default {"overlay":"ModalPopUp_overlay__Tjqla","modal":"ModalPopUp_modal__4Ej6u","btn-close":"ModalPopUp_btn-close__RGrFs"};